import { GrantTypes } from '../../../api/configurations/oauth2/types';
import { CDN_IMG_URL_REGEX } from '../../../constants';

export const DefaultGrandType = [
  GrantTypes.password,
  GrantTypes.authorization_code,
  GrantTypes.refresh_token
];

export const grantTypes = (isServer: boolean, grants?: GrantTypes[]): GrantTypes[] => {
  if (isServer) {
    return [GrantTypes.client_credentials];
  }

  if (!grants || (Array.isArray(grants) && grants.length === 0)) {
    return DefaultGrandType;
  }

  return grants;
};

export const getValidLogoUrl = (url: string | undefined): string | undefined => {
  if (url && !CDN_IMG_URL_REGEX.test(url)) {
    return '';
  }

  return url;
};
